import type { auth as en } from '@/i18n/locales/en/auth';
import type { Translation } from '@/i18n/types';

export const auth: Translation<typeof en> = {
  signInFailed: 'Error al iniciar sesión',
  checkingSession: 'Comprobando tu sesión…',
  redirectingToSignIn: 'Redirigiendo al inicio de sesión…',
  signingIn: 'Iniciando sesión…',
  backToDashboard: 'Volver al panel',
};
